import { Variant } from '@mui/material/styles/createTypography'
import { formatCurrency } from '../helpers/formatting/currency-formatter/currencyFormatter'
import { Typography } from '@mui/material'
import { forwardRef } from 'react'

type CurrencyDisplayProps = {
  value: number
  displayTextVariant?: Variant | undefined
  prefixLabel?: string | undefined
  isLink?: boolean
}

/**
 * CurrencyDisplay formats a currency value and displays it as expected
 * @param value the currency value to be displayed
 * @param displayTextVariant (Optional) What MUI font variant the text should display as
 * @param prefixLabel (Optional) What to prefix the curreny value with e.g. 'Total'
 * @returns Formatted Currency Value
 */
const CurrencyDisplay = forwardRef<HTMLDivElement, CurrencyDisplayProps>(
  (
    {
      value,
      displayTextVariant = 'body2',
      prefixLabel,
      isLink = false,
      ...otherProps
    },
    ref
  ) => {
    const formattedCurrency = formatCurrency(value)
    return (
      <Typography
        ref={ref}
        variant={displayTextVariant}
        color={isLink ? 'primary' : 'black'}
        {...otherProps}
      >
        {prefixLabel
          ? prefixLabel + ' ' + formattedCurrency
          : formattedCurrency}
      </Typography>
    )
  }
)

CurrencyDisplay.displayName = 'CurrencyDisplay'

export default CurrencyDisplay
